<div class="billingHeader">
  <div class="billingHeader__title">
    <app-ds-typography
      [tag]="'h3'"
      [size]="fontSize.XS"
      [color]="fontColor.Primary"
      [fontFamily]="fontFamily.SemiBold"
      [text]="'BOOKING_MODULE.BILLING.EMIT_BILL' | transloco">
    </app-ds-typography>
  </div>
  <div class="billingHeader__description">
    <app-ds-typography
      [tag]="'p'"
      [size]="fontSize.XXS"
      [color]="fontColor.Secondary"
      [fontFamily]="fontFamily.Regular"
      [text]="'BOOKING_MODULE.BILLING.BILLING_SUBTITLE' | transloco">
    </app-ds-typography>
  </div>
</div>
